/** @jsxImportSource @emotion/react */

import { Grid, useMediaQuery, useTheme } from '@mui/material';
import Layout from '../Layout';
import Breadcrumb from '../../Components/Breadcrumb'

function PageLayout(props) {
    const { breadcrumb, showSidebar, hideSidebarGrid, calculateHeight, isObjectionScreen } = props;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const { show } = breadcrumb || {};
    
    return (
        <Layout showSidebar={showSidebar || false} isObjectionScreen={isObjectionScreen} hideSidebarGrid={hideSidebarGrid || false}>
            <Grid container css={{ /* overflow: "auto",  position: "fixed" , right: 0, bottom: isSmallScreen ? "65px" : 0, height: isSmallScreen ? "calc(100vh - 175px)" : "calc(100vh - 80px)", */ height: "100%", backgroundColor: "#F7FAFC", width: isSmallScreen ? "100%" : "100%", borderRadius: isSmallScreen ? "20px 20px 0 0" : "20px 0 0 0" }}>
                {!isSmallScreen && <Grid container item justifyContent={"flex-end"} alignItems={"center"} xs={12} css={{ backgroundColor: "#F7FAFC", boxShadow: "0px 0px 6px #00000026", height: "60px", borderRadius: "12px 0 0 0", display: 'flex', justifyContent: 'space-between', paddingLeft: 30 }}>
                    <Grid item>
                        {show && <Breadcrumb {...breadcrumb} isObjectionScreen={isObjectionScreen} />}
                    </Grid>
                    <Grid item css={{ marginRight: "30px" }}>
                        <img src="/images/icon_info.svg" alt="Info Icon" css={{ width: "25px", height: "25px" }} />
                    </Grid>
                </Grid>}
                <Grid item xs={12} css={{ height: (!isSmallScreen || calculateHeight) ? "calc(100% - 60px)" : "100%", padding: "30px", overflow: 'auto' }}>
                    {props.children}
                </Grid>
            </Grid>
        </Layout>
    );
}

export default PageLayout;